import { render } from "./MenuListComponent.vue?vue&type=template&id=b1e7819c&scoped=true"
import script from "./MenuListComponent.vue?vue&type=script&lang=js"
export * from "./MenuListComponent.vue?vue&type=script&lang=js"

import "./MenuListComponent.vue?vue&type=style&index=0&id=b1e7819c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1e7819c"]])

export default __exports__